export class GridStateHelper {
}

// Grid View Names
export const VIEW_STATE_PROMO = 'promo';
export const VIEW_STATE_PROMO_FILTER_CUSTOMER = 'promo-filter-customer';
export const VIEW_STATE_PROMO_RPT_SUMMARY = 'pr_summary';
export const VIEW_STATE_PROMO_RPT_SERVICE_SUMMARY = 'pr_service_summary';
export const VIEW_STATE_PROMO_RPT_INVOICE_SUMMARY = 'pr_invoice_summary';

export const VIEW_STATE_BOLT_ON = 'bolt-on';
export const VIEW_STATE_BOLT_ON_FILTER_CUSTOMER = 'bolt-on-filter-customer';
export const VIEW_STATE_BO_RPT_SUMMARY = 'bo_summary';
export const VIEW_STATE_BO_RPT_SERVICE_SUMMARY = 'bo_service_summary';
export const VIEW_STATE_BO_RPT_INVOICE_SUMMARY = 'bo_invoice_summary';

export const VIEW_STATE_PREDEFINED_PREMISES = 'predefined-premises';
